import React, { useEffect } from "react";

const getClassByPosition = (position) => {
  const colors = ["blue", "red", "yellow", "green"];
  return colors[(position - 1) % colors.length];
};

export default ({ logoText = 'Avri', fontSize }) => {
  
  useEffect(() => {
    const logoEl = document.querySelector(".logo-text");

    if (logoEl.childElementCount <= 1) {
      const logo = logoEl.innerHTML.trim();
      logoEl.removeChild(logoEl.firstChild);

      logo.split("").forEach((char, index) => {
        const letter = document.createElement("h1");
        const position = index + 1;

        if (char === " ") {
          letter.className = "space";
          letter.innerHTML = "&nbsp;";
        } else {
          letter.className = getClassByPosition(position);
          letter.appendChild(document.createTextNode(char));
        }

        logoEl.appendChild(letter);
      });
    }
  }, [logoText]);

  return (
    <>
      <div className="searchLogo">
        <div style={{ fontSize }} className="logo-text">{logoText}</div>
      </div>
    </>
  );
};